import { render, staticRenderFns } from "./ActiveTrips.vue?vue&type=template&id=2ef201fd"
import script from "./ActiveTrips.vue?vue&type=script&setup=true&lang=js"
export * from "./ActiveTrips.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports